"use strict";
// IMPORTS
// Required libraries that are imported for side-effects. Polyfills and shims go here.
// TODO: Most of these polyfills are actually used by Kaavio. Be sure to include them when separating
require("whatwg-fetch");
// Import styles
// TODO: Use material design
// TODO: Use shadow DOM to encapsulate styles
// TODO: State in docs that Webpack/browserify will automatically bring styles in when bundling
require("roboto-fontface/css/roboto/roboto-fontface.css");
// Import internal libraries for side-effects.
require("./WebComponent");
// Exports
var Pvjs_1 = require("./Pvjs");
exports.Pvjs = Pvjs_1.Pvjs;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLFVBQVU7QUFDVixzRkFBc0Y7QUFDdEYscUdBQXFHO0FBQ3JHLHdCQUFzQjtBQUV0QixnQkFBZ0I7QUFDaEIsNEJBQTRCO0FBQzVCLDZDQUE2QztBQUM3QywrRkFBK0Y7QUFDL0YsMERBQXdEO0FBRXhELDhDQUE4QztBQUM5QywwQkFBd0I7QUFFeEIsVUFBVTtBQUNWLCtCQUE4QjtBQUFyQixzQkFBQSxJQUFJLENBQUEifQ==


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/index.js
// module id = 481
// module chunks = 0